export const API_BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const testIds = {
  nav: {
    logo: "nav-logo",
    linkAbout: "nav-link-about",
    linkServices: "nav-link-services",
    linkBootcamps: "nav-link-bootcamps",
    linkContact: "nav-link-contact",
    cta: "nav-cta-book",
  },
  hero: {
    title: "hero-title",
    ctaPrimary: "hero-cta-primary",
    ctaSecondary: "hero-cta-secondary",
  },
  about: { section: "about-section" },
  services: { section: "services-section" },
  bootcamps: {
    section: "bootcamps-section",
    card: (slug) => `bootcamp-card-${slug}`,
    registerBtn: (slug) => `bootcamp-register-btn-${slug}`,
    dialog: "bootcamp-dialog",
    dialogSubmit: "bootcamp-dialog-submit",
    inputName: "bootcamp-input-name",
    inputEmail: "bootcamp-input-email",
    inputPhone: "bootcamp-input-phone",
    inputExperience: "bootcamp-input-experience",
    inputNotes: "bootcamp-input-notes",
  },
  contact: {
    section: "contact-section",
    inputName: "contact-input-name",
    inputEmail: "contact-input-email",
    inputSubject: "contact-input-subject",
    inputMessage: "contact-input-message",
    submit: "contact-submit-button",
  },
  chat: {
    toggle: "chat-toggle-button",
    panel: "chat-panel",
    input: "chat-input",
    send: "chat-send-button",
    close: "chat-close-button",
    message: (idx) => `chat-message-${idx}`,
  },
  payment: {
    successRoot: "payment-success-root",
    successBackHome: "payment-success-back-home",
    statusText: "payment-status-text",
  },
};
